// extracted by mini-css-extract-plugin
module.exports = {"duration__stops":"duration__stops-3d-eB"};